import {DomainObject} from 'shared/DomainObject';
import {observable} from 'mobx';

class Department extends DomainObject {
  @observable id;
  @observable name;
}

export default Department;

